import { inputFieldPlugin } from '@/features/settingsManagement/fieldManagement/edit/plugin/inputFieldPlugin/inputFieldPlugin.js'
import TextareaFieldPlugin from '@/features/settingsManagement/fieldManagement/edit/plugin/textareaFieldPlugin/TextareaFieldPlugin.vue'
import TextareaFieldPluginValueRenderer from '@/features/settingsManagement/fieldManagement/edit/plugin/textareaFieldPlugin/TextareaFieldPluginValueRenderer.vue'

export const textareaFieldPlugin = {
  type: 'textarea',
  component: TextareaFieldPlugin,
  valueRenderer: TextareaFieldPluginValueRenderer,
  defaultExtraData: {
    placeholder: 'Enter...',
    fieldType: 'input',
    inputMode: 'text',
  },
  getValidations({ props }) {
    return inputFieldPlugin.getValidations({ props })
  },
}
